import { type ReactNode } from 'react';
import { NotSupportedActivityContent } from '@repo/customer-registration-kit/organizations/not-supported-activity/not-supported-activity-content';
import styles from './not-supported-activity-route.module.css';

export function NotSupportedActivityRoute(): ReactNode {
  return (
    <div className={styles.page}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <NotSupportedActivityContent />
        </div>
      </div>
    </div>
  );
}
